import _findIndex from 'lodash/findIndex';
/**
 * @desc  GroupService class.
 * @ngInject
 */
export default class CategoryOfDepartureService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $rootScope, $q, $log, $http
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;

    this.categoriesOfDeparture = [];

    this.$rootScope.$on('scr.select', () => {
      this.categoriesOfDeparture.splice(0, this.categoriesOfDeparture.length);
    });
  }

  getAll() {
    if (this.categoriesOfDeparture.length > 0) {
      return this.$q.resolve(this.categoriesOfDeparture);
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/categoriesOfDeparture`
    }).then(result => {
      this.categoriesOfDeparture = result.data.categoriesOfDeparture;
      return this.categoriesOfDeparture;
    }, err => this.$q.reject(err));
  }

  add(categoryOfDeparture) {
    categoryOfDeparture.isSystem = false;
    categoryOfDeparture.isTransfer = false;
    const copyCategory = {};
    angular.copy(categoryOfDeparture, copyCategory);
    return this.$http({
      method: 'POST',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/categoriesOfDeparture`,
      data: {categoryOfDeparture}
    }).then(result => {
      copyCategory.id = result.data.id;
      this.categoriesOfDeparture.push(copyCategory);
      return result.data.id;
    }, err => this.$q.reject(err));
  }

  edit(categoryOfDeparture) {
    const copyCategory = {};
    angular.copy(categoryOfDeparture, copyCategory);
    return this.$http({
      method: 'PUT',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/categoriesOfDeparture/${categoryOfDeparture.id}`,
      data: {categoryOfDeparture}
    }).then(() => copyCategory.id, err => this.$q.reject(err));
  }

  delete(id) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/categoriesOfDeparture/${id}`
    }).then(result => {
      const idToRemove = _findIndex(this.categoriesOfDeparture, ['id', id]);
      this.categoriesOfDeparture.splice(idToRemove, 1);
      return result;
    }, err => this.$q.reject(err));
  }
}
